import React from 'react';
import startCase from 'lodash/startCase';
import classNames from 'classnames';
import { Chip } from '@vectord/components';

import styles from './SuperBatchTypeChip.module.scss';

function SuperBatchTypeChip({ batchType, className }) {
  return (
    <Chip className={classNames(styles.root, className)}>
      {startCase(batchType)}
    </Chip>
  );
}

export default SuperBatchTypeChip;
